module.exports = __webpack_public_path__ + "img/logo-installment-KCC.c8116938.png";